import React from "react"
import { Field, ErrorMessage } from "formik"
import style from "./input.module.scss"

export default class Input extends React.Component {
  constructor(props) {
    super(props)
    this.inputRef = React.createRef()
    this.cbInputRef = null
    this.setInputRef = element => {
      this.cbInputRef = element
    }
    this.state = { focused: false, empty: true }
    this.inputMutationObserver = null
    this.latestInput = ""
  }

  componentDidMount() {
    const activeRef = this.cbInputRef ? this.cbInputRef : this.inputRef.current
    if (activeRef) {
      activeRef.addEventListener("focus", () => {
        this.setState(oldState => ({ ...oldState, focused: true }))
      })

      activeRef.addEventListener("blur", () => {
        const newStateFragment = { focused: false, empty: true }
        if (
          (activeRef.hasOwnProperty("value") && activeRef.value) ||
          activeRef.innerText
        )
          newStateFragment.empty = false
        this.setState(oldState => ({ ...oldState, ...newStateFragment }))
      })
    }
    // if(this.cbInputRef) {
    //   this.cbInputRef.addEventListener("blur", () => {console.log('aaaaaaaaaaaaaaaaaaaaa')
    //     this.props.doValidate();
    //   })
    // }
    // if (this.cbInputRef && window.document.documentMode) {
    //   this.inputMutationObserver = new MutationObserver(
    //     (mutationList, observer) => {
    //       for (let mutation of mutationList) {
    //         if (mutation.type === "characterData") {
    //           this.latestInput = mutation.target.data
    //         }
    //       }
    //     }
    //   )
    //   this.inputMutationObserver.observe(this.cbInputRef, {
    //     characterData: true,
    //     subtree: true,
    //   })
    //   this.cbInputRef.addEventListener("blur", () => {
    //     if (this.form) {
    //       this.form.setFieldValue("message", this.latestInput)
    //       this.props.doValidate()
    //     }
    //   })
    // }
  }

  componentWillUnmount() {
    if (this.inputMutationObserver) {
      this.inputMutationObserver.disconnect()
      this.inputMutationObserver = null
    }
  }

  render() {
    const placeholder = this.props.placeholder
    const reducedProps = { ...this.props }
    delete reducedProps.placeholder

    let inputClasses = [style.customInput]
    if (this.state.focused) inputClasses.push("focused")
    if (!this.state.empty) inputClasses.push("filled-in")
    inputClasses = inputClasses
      .reduce((acc, val) => acc.concat(val, " "), "")
      .trimEnd()

    let fieldChildren = this.props.children
    if ("function" === typeof this.props.children) {
      fieldChildren = cbObject => {
        this.form = cbObject.form
        return this.props.children({
          ...cbObject,
          cbRef: this.setInputRef,
        })
      }
    }

    return (
      <div className={`custom-input ${inputClasses}`}>
        <div className={`label-wrapper ${style.labelWrapper}`}>
          <div className={`input-label-ph ${style.labelPh}`}></div>
          <div className={`input-label ${style.label}`}>{placeholder}</div>
          <div className={`input-wrapper ${style.wrapper}`}>
            <Field {...reducedProps} innerRef={this.inputRef}>
              {fieldChildren}
            </Field>
          </div>
        </div>
        <div className={`input-error ${style.error}`}>
          <ErrorMessage name={this.props.name} />
        </div>
      </div>
    )
  }
}
